import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActivityAnalysisNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21 10.33c-.216 0-.43.027-.64.08l-4.18-7.73-8.91 16.79-2.45-4.52a2.688 2.688 0 10-1.18.64l3.65 6.74 8.9-16.79 2.99 5.51a2.667 2.667 0 101.82-.72zM2.95 14.32A1.326 1.326 0 114.33 13c.001.241-.068.478-.2.68a1.3 1.3 0 01-1.13.65.09.09 0 01-.05-.01zm18.05.01a1.33 1.33 0 110-2.66 1.33 1.33 0 010 2.66z"
        fill=""
      />
    </svg>
  )
);
SvgActivityAnalysisNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActivityAnalysisNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActivityAnalysisNormalSmall;
